import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { Content } from './styles';

const PieChartLoader = props => {
  const themeContext = useContext(ThemeContext);
  return (
    <Content
      // viewBox="0 0 350 100"
      speed={2}
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColor}
      primaryopacity={1}
      secondaryospacity={0.6}
      {...props}
      width={350}
      height={200}
    >
      <circle cx="105" cy="60" r="50" />
      <rect x="225" y="30" rx="0" ry="0" width="40" height="15" />
      <rect x="275" y="30" rx="0" ry="0" width="140" height="15" />

      <rect x="225" y="60" rx="0" ry="0" width="40" height="15" />
      <rect x="275" y="60" rx="0" ry="0" width="170" height="15" />

      <rect x="225" y="90" rx="0" ry="0" width="40" height="15" />
      <rect x="275" y="90" rx="0" ry="0" width="135" height="15" />

      <rect x="225" y="120" rx="0" ry="0" width="40" height="15" />
      <rect x="275" y="120" rx="0" ry="0" width="150" height="15" />
    </Content>
  );
};

export default PieChartLoader;
